import { Outlet } from "react-router-dom";

import { AccessDeniedPage } from "../../../pages/auth-info/containers/access-denied-page";
import { NoFarmsPage } from "../../../pages/auth-info/containers/no-farms-page";
import { SessionCheckFailedPage } from "../../../pages/auth-info/containers/session-check-failed-page";
import { SpinnerCenter } from "../../../shared/components/spinner-center/spinner-center";
import { useDictionaryLoader } from "../../../shared/hooks/use-dictionary-loader";
import { useFarmFeatureToggles } from "../../../shared/hooks/use-farm-feature-toggles";
import { useAuthGate } from "../../hooks/use-auth-gate";
import { useCanViewWeb } from "../../hooks/use-web-permissions";

import { useAvailableFarmsGate } from "./use-available-farms-gate";

export const ProtectedRoute = (): JSX.Element => {
  const { isAuthenticated, isLoadingUserDto, sessionCheckFailure, retry } = useAuthGate();
  const canViewWeb = useCanViewWeb();
  const hasAccess = isAuthenticated && canViewWeb;
  const farms = useAvailableFarmsGate(hasAccess);
  const initialDictionariesLoaded = useDictionaryLoader(hasAccess);
  useFarmFeatureToggles();

  if (sessionCheckFailure === "forbidden") {
    return <AccessDeniedPage />;
  }
  if (sessionCheckFailure === "error") {
    return <SessionCheckFailedPage onRetry={retry} />;
  }
  if (isLoadingUserDto) {
    return <SpinnerCenter msg="Загружаются пользовательские данные..." />;
  }
  if (!isAuthenticated) {
    return <SpinnerCenter msg="Ожидание авторизации..." />;
  }
  if (!canViewWeb) {
    return <AccessDeniedPage isSignedIn={true} />;
  }
  if (farms.status === "empty") {
    return <NoFarmsPage onRetry={farms.retry} />;
  }
  if (farms.status !== "ready") {
    return <SpinnerCenter msg="Загружаются хозяйства..." />;
  }
  if (!initialDictionariesLoaded) {
    return <SpinnerCenter msg="Загружаются справочники..." />;
  }

  return <Outlet />;
};
